import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logoImage from "../assets/LU-2026--Main-Revised.png";

const LU_YELLOW = "#ffeb00";
const LU_RED    = "#FF0000";

const Icon = ({ name, color = "currentColor", size = 20 }) => {
  const props = { width: size, height: size, stroke: color, strokeWidth: 2, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "dashboard": return (
      <svg viewBox="0 0 24 24" {...props}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>
    );
    case "history": return (
      <svg viewBox="0 0 24 24" {...props}><path d="M12 8v4l3 3" /><circle cx="12" cy="12" r="9" /></svg>
    );
    case "login-history": return (
      <svg viewBox="0 0 24 24" {...props}><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
    );
    case "profile": return (
      <svg viewBox="0 0 24 24" {...props}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
    );
    case "settings": return (
      <svg viewBox="0 0 24 24" {...props}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
    );
    case "support": return (
      <svg viewBox="0 0 24 24" {...props}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
    );
    case "signout": return (
      <svg viewBox="0 0 24 24" {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
    );
    case "link": return (
      <svg viewBox="0 0 24 24" {...props} strokeWidth={3}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>
    );
    default: return null;
  }
};

const LUDashboard = () => {
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const navigate = useNavigate();

  const menuItems = [
    { name: "Dashboard", id: "dashboard" },
    { name: "History", id: "history" },
    { name: "Account Login History", id: "login-history" },
    { name: "My Profile", id: "profile" },
    { name: "Settings", id: "settings" },
    { name: "Help & Support", id: "support" }
  ];

  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", display: "flex", fontFamily: "'Inter', sans-serif" }}>
      
      {/* Sidebar */}
      <aside style={{ width: "290px", backgroundColor: LU_YELLOW, minHeight: "100vh", padding: "40px 15px", display: "flex", flexDirection: "column" }}>
        
        {/* Logo Section */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "40px", padding: "0 10px", cursor: "pointer" }} onClick={() => navigate("/")}>
          <img src={logoImage} alt="Legitimately U" style={{ height: "40px", objectFit: "contain" }} />
        </div>

        {/* Menu Items */}
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {menuItems.map(item => (
            <div 
              key={item.id}
              onClick={() => setActiveMenu(item.name)}
              style={{
                padding: "14px 20px", borderRadius: "30px", cursor: "pointer",
                display: "flex", alignItems: "center", gap: "15px",
                backgroundColor: activeMenu === item.name ? LU_RED : "transparent",
                color: activeMenu === item.name ? "white" : "#1e293b",
                fontWeight: activeMenu === item.name ? 700 : 700,
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
              }}
            >
              <Icon name={item.id} size={18} color={activeMenu === item.name ? "white" : "#1e293b"} />
              <span style={{ fontSize: "14px" }}>{item.name}</span>
            </div>
          ))}
        </div>

        {/* Sign Out */}
        <div style={{ marginTop: "auto", padding: "20px" }}>
          <div 
            onClick={() => navigate("/")}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "12px", color: LU_RED, fontWeight: 800, fontSize: "14px" }}
          >
            <Icon name="signout" size={20} color={LU_RED} />
            <span>Sign Out</span>
          </div>
        </div>
      </aside>

      {/* Content Area */}
      <main style={{ flex: 1, padding: "30px 40px" }}>
        
        {/* Status Badge */}
        <div style={{ marginBottom: "30px" }}>
           <div style={{ 
              display: "inline-flex", alignItems: "center", gap: "12px", 
              background: "#fff", padding: "10px 20px", borderRadius: "12px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0"
           }}>
              <span style={{ fontSize: "13px", fontWeight: 700, color: "#64748b" }}>You are currently logged in</span>
              <div style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#10b981", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon name="link" size={10} color="white" />
              </div>
           </div>
        </div>

        {/* Dynamic Card Area */}
        <div style={{ 
          background: "white", borderRadius: "24px", padding: "40px", 
          minHeight: "calc(100vh - 150px)", border: "1px solid #f1f5f9", boxShadow: "0 10px 30px rgba(0,0,0,0.02)"
        }}>
          
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "50px" }}>
            <h1 style={{ fontSize: "2.4rem", fontWeight: 900, color: "#111827" }}>Dashboard</h1>
            
            <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
              <div style={{ textAlign: "right" }}>
                <h3 style={{ fontSize: "16px", fontWeight: 800, marginBottom: "8px", color: "#374151" }}>Link or Download Mobile LU App</h3>
                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" style={{ height: "32px", cursor: "pointer" }} />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" style={{ height: "32px", cursor: "pointer" }} />
                </div>
              </div>
              <div style={{ 
                width: "80px", height: "80px", background: "#fff", borderRadius: "12px", 
                border: "1px solid #e5e7eb", padding: "10px", display: "flex", alignItems: "center", justifyContent: "center" 
              }}>
                <svg viewBox="0 0 24 24" width="60" height="60"><path d="M3 3h7v7H3V3zm3 3v1h1V6H6zm11-3h7v7h-7V3zm3 3v1h1V6h-1zM3 17h7v7H3v-7zm3 3v1h1v-1H6zm11-3h7v7h-7v-7zm3 3v1h1v-1h-1zM11 3h2v2h-2V3zm0 4h2v2h-2V7zM7 11h2v2H7v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-4 4h2v2h-2v-2zm4 4h2v2h-2v-2z" fill="#000" /></svg>
              </div>
            </div>
          </div>

          {/* Cards Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "30px" }}>
             {[
               { title: "LU Video Tutorial", img: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80", play: true },
               { title: "Where to use LU", img: "https://images.unsplash.com/photo-1620712943543-bcc4628c9757?w=800&q=80" },
               { title: "Share LU", img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80" },
               { title: "LU Website", img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" }
             ].map(card => (
               <div key={card.title} style={{ borderRadius: "24px", overflow: "hidden", border: "1px solid #f3f4f6", boxShadow: "0 10px 25px rgba(0,0,0,0.02)", transition: "transform 0.2s" }} className="hover-lift">
                 <div style={{ backgroundColor: LU_YELLOW, padding: "14px", textAlign: "center", fontWeight: 800, fontSize: "14px", color: "#111827", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                   {card.title}
                 </div>
                 <div style={{ height: "200px", position: "relative" }}>
                   <img src={card.img} alt={card.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                   {card.play && (
                     <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.1)" }}>
                        <div style={{ 
                          width: "56px", height: "56px", background: LU_RED, borderRadius: "50%", 
                          display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                          boxShadow: `0 8px 24px ${LU_RED}44`
                        }}>
                          <svg viewBox="0 0 24 24" width="28" height="28" fill="white"><path d="m7 4 12 8-12 8V4z" /></svg>
                        </div>
                     </div>
                   )}
                 </div>
               </div>
             ))}
          </div>

          {/* Bottom Banner */}
          <div style={{ marginTop: "60px", padding: "40px", borderRadius: "32px", background: "#f9fafb", border: "1px solid #f3f4f6", textAlign: "center" }}>
            <h2 style={{ fontSize: "1.8rem", fontWeight: 900, marginBottom: "16px", color: "#111827" }}>Secure Identity Collective</h2>
            <p style={{ color: "#6b7280", maxWidth: "700px", margin: "0 auto", lineHeight: 1.6, fontSize: "15px" }}>
              Your sovereign identity is managed via local encrypted hardware nodes. LegitimatelyU never sees your private biometric signature, only the verification proof.
            </p>
          </div>
        </div>

      </main>

      {/* Floating Helpers */}
      <div style={{ position: "fixed", bottom: "40px", right: "40px", display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ width: "56px", height: "56px", borderRadius: "50%", background: LU_YELLOW, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 8px 25px rgba(0,0,0,0.1)", cursor: "pointer" }}>
          <Icon name="support" size={24} color="#000" />
        </div>
        <div style={{ width: "56px", height: "56px", borderRadius: "50%", background: LU_YELLOW, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 8px 15px rgba(0,0,0,0.1)", cursor: "pointer" }}>
           <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#000" strokeWidth="2"><path d="M11 5L6 9H2v6h4l5 4V5zM19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" /></svg>
        </div>
      </div>
      
      <style>{`
        .hover-lift:hover { transform: translateY(-5px); }
      `}</style>
    </div>
  );
};

export default LUDashboard;
